export default {
  data: () => ({
    infiniteScrollContainer: null,
    infiniteScrollEdge: 100,
    infiniteScrollOnScrollEnd: x => x
  }),

  methods: {
    detectComingEnd (e) {
      const {top: offset, height} = this.infiniteScrollContainer.getBoundingClientRect()
      const {bottom} = this.infiniteScrollContainer.lastElementChild.getBoundingClientRect()
      return ((bottom - offset - height) < this.infiniteScrollEdge) &&
        this.infiniteScrollOnScrollEnd(e)
    }
  },

  watch: {
    infiniteScrollContainer (current, old) {
      if (old) old.removeEventListener('scroll', this.detectComingEnd)
      current.addEventListener('scroll', this.detectComingEnd)
    }
  },

  beforeDestroy () {
    const container = this.infiniteScrollContainer
    container && container.removeEventListener('scroll', this.detectComingEnd)
  }
}



// WEBPACK FOOTER //
// ./src/mixins/infiniteScroll.js